<body class="d-body">
    <div class="body create-course">
        <iq-central-front-end-navbar></iq-central-front-end-navbar>
        <div class="container">
            <div class="row">
                <div class="col-lg-2 col-sm-12"></div>
                <div class="col-lg-8 col-sm-12">
                    <ul class="nav nav-pills mb-3 justify-content-center mt-5">
                        <li class="nav-item" [routerLink]="['/courses/edit-course', courseCode]">
                            <a class="nav-link">
                                <span class="number">1</span> COURSE OVERVIEW</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link active">
                                <span class="number">2</span> EDIT LESSONS</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link"><span class="number">3</span>CONTENT</a>
                        </li>
                    </ul>
                </div>
                <div class="col-lg-2 col-sm-12"></div>
            </div>
        </div>

        <section>
            <div class="py-5 container">
                <div class="py-5 text-center">
                    <h3 class="font36">
                        This course contains {{ lessons?.length }} Lesson(s)
                    </h3>
                    <p class="font18">
                        You can create more lessons using our platform below
                    </p>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                    <div [formGroup]="lessonForm">
                        <p class="text-grey font14 mb-0">ADD LESSON</p>
                        <div class="p-r edit">
                            <input #lessonName formControlName="title" placeholder="Enter a lesson name" type="text" class="add-lesson-name form-control" [ngClass]="{
                  'is-invalid':
                    lessonForm.get('title').errors &&
                    lessonForm.get('title').touched
                }" />
                        </div>
                        <div class="invalid-feedback mt-0 p-0">
                            Please enter a lesson name
                        </div>
                    </div>
                    <div class="text-right">
                        <img src="assets/icons/more-options.png" alt="" />
                        <p class="mb-0 text-grey font14 mt-3">
                            {{ lessons.length }} LESSON(S)
                        </p>
                    </div>
                </div>
                <div class="text-center my-4 d-flex justify-content-end">
                    <button class="btn bg-white px-4 mr-3" (click)="finish('courses')" [disabled]="lessonForm.invalid">
            Finish
          </button>
                    <button class="btn bg-white " (click)="addLessonContent()" [disabled]="lessonForm.invalid">
            Add Content
            <span *ngIf="isLoading" class="ml-4"
              ><i class="fa fa-spinner fa-spin"></i
            ></span>
          </button>
                </div>
                <div id="accordion">
                    <div class="card" *ngFor="let lesson of lessons; index as i">
                        <div class="card-header" [attr.id]="'edit' + i">
                        <!-- <div class="card-header" [attr.id]="'headerOne' + i"> -->
                            <div class="d-flex justify-content-between ">
                                <a data-toggle="collapse" [attr.href]="'#collapseOne' + i" aria-expanded="true" [attr.aria-controls]="'collapseOne' + i" class="grow">
                                    <div class="text-left ">
                                        <p class="text-grey font14 mb-0">LESSON {{ i + 1 }}</p>
                                        <div class="p-r edit font24" [formGroup]="lessonFormEdit">
                                            <input type="text" [attr.id]="'input' + i" class="edit-lesson-name" formControlName="title" [readonly]="true" placeholder="{{ lesson.title }}" />
                                            <label (click)="updateLessonName(lesson?.id, i)" [disabled]="!lessonFormEdit.valid" for="edit" class="ml-2 text-green visibility click " [attr.id]="'visible' + i"><i class="fa fa-floppy-o"></i
                                            ></label>
                                        </div>
                  </div>
                </a>
                <div class="text-right">
                  <button class="btn bg-white ml-2" (click)="editLesson(i)">
                    Edit
                  </button>
                                    <i class="fa fa-question-circle" ngbTooltip="Click edit to change lesson name" tooltipClass="myToolTip"></i>
                                    <button class="btn btn-primary-color ml-2" (click)="addContent(lesson?.id)">
                    Add Content
                    <span *ngIf="isLoading" class="ml-4"
                      ><i class="fa fa-spinner fa-spin"></i
                    ></span>
                  </button>
                                    <button class="btn btn-danger ml-2" (click)="deleteLesson(lesson?.id)">
                    Delete
                  </button>
                                    <p class="mb-0 text-grey font14 mt-3">
                                        {{ lesson?.lessonContents?.length }} CONTENTS
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div [attr.id]="'collapseOne' + i" class="collapse " [attr.aria-labelledby]="'headingOne' + i" [attr.data-parent]="'#accordion'" *ngFor="let content of lesson?.lessonContents; index as j">
                            <div class="card-body">
                                <div class="card-table table-responsive">
                                    <table class="table no-wrap" id="myTable">
                                        <tbody>
                                            <tr class="my-3">
                                                <td class="mx-3 no-wrap">0{{ j + 1 }}</td>
                                                <td *ngIf="content?.contentType === 'QUIZ'">
                                                    <img src="assets/icons/checklist.png" alt="" />
                                                </td>
                                                <td *ngIf="content?.contentType === 'video'">
                                                    <img src="assets/icons/youtube.png" alt="" />
                                                </td>
                                                <td *ngIf="content?.contentType === 'pdf'">
                                                    <img src="assets/icons/book.png" alt="" />
                                                </td>
                                                <td>
                                                    <div class="mx-2 d-flex justify-content-around align-items-center">
                                                        <div>
                                                            <p class="font24 mb-0">{{ content?.name }}</p>
                                                            <p class="mt-1 font12 text-grey" *ngIf="content?.contentType === 'pdf'">
                                                                {{ content?.contentType }}- {{ content?.lessonContentPdf?.minutesRead }} MINUTES
                                                            </p>
                                                            <p class="mt-1 font12 text-grey" *ngIf="content?.contentType === 'video'">
                                                                {{ content?.contentType }}- {{ content?.lessonContentVideo?.duration }} MINUTES
                                                            </p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>
                                                    <div class="d-flex">
                                                        <div class="font12 text-grey click mr-3" (click)="deleteLessonContent(content?.id, j)">
                                                            DELETE
                                                        </div>
                                                        <div class="text-green font12 click" *ngIf="content?.contentType === 'QUIZ'" (click)="editQuiz(lesson?.id)">
                                                            EDIT
                                                        </div>
                                                        <div class="text-green font12 click" *ngIf="content?.contentType === 'pdf'" (click)="editPdf(lesson?.id, content?.id)">
                                                            EDIT
                                                        </div>
                                                        <div class="text-green font12 click" *ngIf="content?.contentType === 'video'" (click)="editVideo(lesson?.id, content?.id)">
                                                            EDIT
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
    <div class="mt-auto hidden">
        <div class="footer-wrapper container">
            <hr />
            <iq-central-front-end-footer></iq-central-front-end-footer>
        </div>
    </div>
</body>

<!-- delete Modal -->
<div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="d-flex justify-content-between p-4">
                <h5 class="modal-title" id="deleteModalLabel">Confirm Delete</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
            </div>
            <div class="modal-body">
                <p class="font-light px-5">
                    Are you sure you want to delete this Course? Click the ‘No’ button to cancel this action
                </p>
            </div>
            <div class="modal-footer d-flex justify-content-center">
                <button type="button" class="btn btn-secondary bg-white btn-outline-secondary" data-dismiss="modal">
          No
        </button>
                <button type="button" class="btn btn-primary">Yes</button>
            </div>
        </div>
    </div>
</div>